import * as _ from "lodash";
import * as THREE from "three";

export class ObjectHelper {
	constructor(
	){}

	static fixNormal(vector) {
		let t = vector.y;
		vector.y = -vector.z;
		vector.z = t;
	}

	fixNormals(item) {
		// this.appContext.log('Fixing ['+item.type+']: '+item.uuid, 'fix');  // @todo: Proper log filter
		if (item.hasOwnProperty('faces')) {
			_.each(item.faces, (face) => {
				ObjectHelper.fixNormal(face.normal);
				_.each(face.vertexNormals, (vertex) => {
					if (!vertex.hasOwnProperty('fixed')) {
						ObjectHelper.fixNormal(vertex);
						vertex.fixed = true;
					}
				});
			});
			item.normalsNeedUpdate = true;
			item.verticesNeedUpdate = true;
		}
		if (item.hasOwnProperty('geometry'))
			this.fixNormals(item.geometry);
		if (item.hasOwnProperty('children'))
			_.each(item.children, (child) => {
				this.fixNormals(child);
			});
	}

	mirrorUVs(object) {
		object.traverse((mesh) => {
			if (!mesh.hasOwnProperty('geometry'))
				return true;
			let updated = 0;
			let mg = mesh.geometry;
			// console.dir(mesh);
			if (mg.hasOwnProperty('faceVertexUvs') && (mg.faceVertexUvs.length > 1)) {
				_.each(mg.faces, (face, i_f) => {
					_.each(['a', 'b', 'c'], (vert, i_v) => {
						if ((mg.vertices[face[vert]].x < 0) && !mg.faceVertexUvs[1][i_f][i_v].hasOwnProperty('uvMirrored')) {
							mg.faceVertexUvs[1][i_f][i_v].x *= -1;
							mg.faceVertexUvs[1][i_f][i_v].uvMirrored = true;
							updated += 1;
						}
					});
				});
				mg['uvsNeedUpdate'] = true;
				mg['verticesNeedUpdate'] = true;
				// console.dir(mg);
			}
		});
	}

	fixTransforms(item) {
		item.traverse((o) => {
			if (o instanceof THREE.Mesh) {
				o.rotation.z += Math.PI;
			}
		});
	}

	/**
	 * Finds slots in object (by material name)
	 * @param item ThreeJS object to be parsed (and modified)
	 */
	static processSlots(item):{ [key:string]:THREE.Object3D } {
		let slots = {} as any;
		let reSlotName = /^([a-z0-9]+)\.?.*/i;
		// loop through all meshes and find ones with "$" material
		item.traverse(function (o) {
			if (o.hasOwnProperty('material') && o.material.hasOwnProperty('name') && (o.material.name === '$')) {
				let slot_name = '$' + reSlotName.exec(o.name)[1];	// Strip object name from everything after dot
				let a = new THREE.Object3D();
				slots[slot_name] = a;
				a.position.set(
					o.position.x,
					o.position.y,
					o.position.z
				);
			}
		});
		return slots;
	}
}



// WEBPACK FOOTER //
// ./src/script/app3D/ObjectHelper.ts